<template>
  <div class="row">
    <div class="col-xl-6 col-12 my-xl-4 mb-3">
      <div class="card shadow-md border-1 rounded-3 p-2 h-100">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex align-items-center">
              <div class="workflow-icon me-3">
                <i class="bi bi-diagram-3-fill text-primary fs-4"></i>
              </div>
              <div>
                <h5 class="mb-1">{{ workflowData ? workflowData.workflow_name : "Unknown" }}</h5>
                <small class="text-muted">Workflow Details</small>
              </div>
            </div>
            <button 
              class="btn btn-dark rounded-3 fw-bold text-xxs shadow"
              :disabled="exporting"
              @click="$emit('export-workflow')"
            >
              <span v-if="exporting">
                <i class="fas fa-spinner fa-spin me-1"></i>Exporting...
              </span>
              <span v-else>
                <i class="fas fa-file-export me-1"></i>Export Workflow
              </span>
            </button>
          </div>
          <hr class="h-1" />
          <p class="text-xs">
            {{ workflowData ? workflowData.workflow_description : "Unknown" }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-xl-6 col-12 my-xl-4 my-0">
      <div class="row g-4">
        <div class="col-sm-12 col-md-6">
          <icon-card title="Services Selected" :count="workflowData ? workflowData.services.length : 0" icon_class="fas fa-network-wired" />
        </div>
        <div class="col-sm-12 col-md-6">
          <icon-card title="Workflow Services Cost" :count="`R ${workflowData ? workflowData.total_cost : 0.00}`" icon_class="fas fa-money-bill-alt" />
        </div>
        <div class="col-sm-12 col-md-6">
          <icon-card title="Customers Onboarded" :count="workflowData ? workflowData.customers.length : 0" icon_class="fas fa-users" />
        </div>
        <div class="col-sm-12 col-md-6">
          <icon-card title="Current Activation Status" :count="workflowData ? capitalizeString(workflowData.workflow_status) : 'Unknown'" icon_class="far fa-check-circle" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconCard from "@/components/CustomCard/IconCard.vue";

export default {
  name: 'HeaderSection',
  components: {
    IconCard
  },
  props: {
    workflowData: {
      type: Object,
      default: null
    },
    exporting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['export-workflow'],
  methods: {
    capitalizeString(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
}
</script>

<style scoped>
.workflow-icon {
  background: rgba(0, 123, 255, 0.1);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
